import Utils from "../Shared/Utils"
import Constant from "../Shared/Constant"
import NetworkLogic from "../Shared/NetworkLogic";
import UIManager from "../Shared/UIManager";
import SDKManager from "../Shared/SDKManager";
import {Global} from "../Shared/Global";
const i18n = require("LanguageData");

const {ccclass, property} = cc._decorator

@ccclass
export default class LaunchScene extends cc.Component {
    onLoad () {
        // 马甲包默认可能不是横屏，所以需要手动设置下
        Utils.setOrientation("H")
    }

    start () {
        // 延迟是为了减少app启动黑屏时间
        let self = this;
        this.node.runAction(cc.sequence(
            cc.delayTime(0.1),
            cc.callFunc(function () {
                // self.setOff().then(self.loadScene());
                //更新域名获取地址，若为防止串厅,更新地址只使用基础包内配置，可以启用上面一行；默认走下面，可以保持所有域名的统一
                self.setOff().then(self.loadScene);
            })
        ))
    }
    async setOff() {
        this.removeNativeLaunchImage()
        await this.initApp()
        await this.initLanguage()
    }
    
    async initApp() {
        // 生产环境则打开游戏盾//local 默认关闭游戏盾，除非沿用上次配置或直到用户主动切换
        // Constant.Environment === 2 && !Constant.CloseYxd && Utils.setShieldAddress()
        cc.sys.isMobile && jsb.device.setKeepScreenOn(true)
        // 热更文件夹，main.js需要用到。解决覆盖安装找不到热更文件的问题
        cc.sys.localStorage.setItem('HotUpdateStorageFolder', Constant.HotUpdateStorageFolder)
        if (Constant.Environment === 2) {
            let ossAddress = await this.getDomainConfigAddr()
        }
    }
    getDomainConfigAddr() {
        //假装返回了 某个域名配置JSON文件的地址
        cc.log(":=假装返回了 某个域名配置JSON文件的地址")
        NetworkLogic.getOssAddr(function (data) {
         let    ossAddress = data
            this.getServerDomain(ossAddress)
        }.bind(this))
    }

    private getServerDomain(ossAddress): Promise<boolean> {
        return new Promise(resolve => {
            let gottenData = false;
            let xhr = new XMLHttpRequest()
            xhr.responseType = 'json'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    gottenData = true;
                    let res = xhr.response;
                    let closeYxd = res.closeYxd;
                    let addressList = res.ServerAddresses;
                    if (closeYxd === false) {
                        if (!(res.GameShieldAccessKey && res.GameShieldGroupName && res.GameShieldDomain && res.GameShieldPort)) {
                            cc.log("游戏盾配置参数字段内容缺失")
                        }else{
                            // Constant.setParametersForYXD(res.GameShieldAccessKey, res.GameShieldGroupName, res.GameShieldDomain, res.GameShieldPort);
                            //生成游戏盾，并将转发地址加入服务器地址列表末端
                            let yxdAddress = Utils.getShieldAddress(res.GameShieldAccessKey, res.GameShieldGroupName, res.GameShieldDomain, res.GameShieldPort);
                            if (yxdAddress) { addressList.push(yxdAddress); }
                        }
                    }
                    Utils.flushServerList(addressList);
                    cc.log("addressList:="+addressList)
                }
                resolve(gottenData)
            }.bind(this)
            if (ossAddress.charAt(ossAddress.length - 1) !== "/" ){ossAddress = ossAddress + "/"}
            let ossUrl = ossAddress + Constant.WebsiteSign + "/domainList.json?TimeStampDiff="+ Number(new Date())
            xhr.open("GET", ossUrl, true)
            cc.log("ossURL:=" + ossUrl)

            xhr.send()
            // 2秒没有回调则使用默认地址
            this.scheduleOnce(function () {
                resolve(false)
            }, 2)
        })
    }
    private loadScene () {
        let isHotUpdateFinished = cc.sys.localStorage.getItem("HotUpdateFinished") ? true : false
        let nextScene = ""

        if (isHotUpdateFinished) {
            nextScene = "Hall"
        }else {
            nextScene = "HotUpdate"
        }
        cc.log("===加载场景",nextScene);
        cc.director.preloadScene(nextScene, null, function () {
            cc.director.loadScene(nextScene)
        }.bind(this))
    }

    private initLanguage () : Promise<any> {
        return new Promise<any>(async resolve => {
            // 语言设置
            let language = cc.sys.localStorage.getItem("CurrentLanguage")
            if (!language) {
                let languageData = await this.getLanguageData()
                let defaultLanguage = "zh_CN"

                for (let i = 0; i < languageData.length; i++) {
                    const item = languageData[i];
                    item.defaultLang === 0 && (defaultLanguage = item.languageFlag)
                    let lang = item.languageFlag.split("_")
                    // 跟随系统设置
                    if (lang[0] === cc.sys.language) {
                        language = item.languageFlag
                        break
                    }
                }
                
                !language && (language = defaultLanguage)
                cc.sys.localStorage.setItem("CurrentLanguage", language)
            }

            SDKManager.setTags([language])
            i18n.init(language)
            Global.currencySymbol = i18n.t('currency_symbol') ;
            resolve()
        })
    }

    private getLanguageData () : Promise<any> {
        return new Promise<any>(resolve => {
            NetworkLogic.getLanguageList(function (data) {
                resolve(data)
            }.bind(this), function (response) {
                resolve([])
            }.bind(this))
        })
    }

    private removeNativeLaunchImage () {
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("AppController", "removeLaunchImage")
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "removeLaunchImage", "()V");
        }
    }
}
